export default __webpack_public_path__ + "static/media/383.419f17f7.png";